import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { WebModule } from './shared/web.module';

import { MyApp } from './app.component';
import { LeaguesPage } from '../pages/leagues/leagues';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AuthModule } from './shared/auth.module';
import { Ng2ImgFallbackModule } from 'ng2-img-fallback';
//import { LocationStrategy, PathLocationStrategy } from '@angular/common';

import * as env from './shared/env';
import { LeagueService } from './shared/league.service';
import { ToastService } from './shared/toast.service';

@NgModule({
  declarations: [
    MyApp,
    LeaguesPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/activate/activate.module#ActivatePageModule', name: 'ActivatePage', segment: 'action?:mode&:oobCode', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/grouppicks/grouppicks.module#GrouppicksPageModule', name: 'GrouppicksPage', segment: 'groups/:groupid/picks', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/groupstandings/groupstandings.module#GroupstandingsPageModule', name: 'GroupstandingsPage', segment: 'groups/:groupid/standings?limit=:limit', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/groupsummary/groupsummary.module#GroupsummaryPageModule', name: 'GroupsummaryPage', segment: 'groups/:groupid/summary', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/image-editor/image-editor.module#ImageEditorPageModule', name: 'ImageEditorPage', segment: 'image-editor', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/joingroup/joingroup.module#JoingroupPageModule', name: 'JoingroupPage', segment: 'groups/:groupid/join', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login/login.module#LoginPageModule', name: 'LoginPage', segment: 'login', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/match/match.module#MatchPageModule', name: 'MatchPage', segment: 'groups/:groupid/matches/:matchid', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/payment/payment.module#PaymentPageModule', name: 'PaymentPage', segment: 'payment', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/profile/profile.module#ProfilePageModule', name: 'ProfilePage', segment: 'profile', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/recover/recover.module#RecoverPageModule', name: 'RecoverPage', segment: 'recover', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/rules/rules.module#RulesPageModule', name: 'RulesPage', segment: 'groups/:groupid/rules', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/signin/signin.module#SigninPageModule', name: 'SigninPage', segment: 'signin', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/signup/signup.module#SignupPageModule', name: 'SignupPage', segment: 'signup', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/usermatches/usermatches.module#UsermatchesPageModule', name: 'UsermatchesPage', segment: 'groups/:groupid/users/:userid/matches?{upcoming}', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/userpicks/userpicks.module#UserpicksPageModule', name: 'UserpicksPage', segment: 'groups/:groupid/users/:userid/picks', priority: 'low', defaultHistory: [] }
  ]
}),
    AngularFireModule.initializeApp(env.firebaseConfig),
    AngularFireDatabaseModule,
    AuthModule,
    WebModule,
    Ng2ImgFallbackModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LeaguesPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    //{provide: LocationStrategy, useClass: PathLocationStrategy},
    LeagueService,
    ToastService,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts